import React from "react";

import SectionTextBlock from "components/common/SectionTextBlock";

import * as S from "./SectionSponsorshipPolicy.Style";

const SectionSponsorshipPolicy = () => {
  return (
    <S.SectionSponsorshipPolicyContainer className="container">
      <SectionTextBlock
        title="Construção da nossa Política de Patrocínio"
        description={
          <>
            <S.SectionIntergrityProgramText>
              Conheça as <strong>leis e instrumentos normativos</strong> que
              orientam nossa política de patrocínio e garantem conformidade em
              nossas ações.
            </S.SectionIntergrityProgramText>

            <S.SectionSponsorshipPolicyList>
              <li>
                <S.SectionIntergrityProgramText>
                  Decreto 11.129/22 – Vinculado à Lei Anticorrupção
                </S.SectionIntergrityProgramText>
              </li>
              <li>
                <S.SectionIntergrityProgramText>
                  Instrução Normativa ANCINE n.º 158 (23/12/2021)
                </S.SectionIntergrityProgramText>
              </li>
              <li>
                <S.SectionIntergrityProgramText>
                  Lei nº 12.846/13 – Lei Anticorrupção
                </S.SectionIntergrityProgramText>
              </li>
              <li>
                <S.SectionIntergrityProgramText>
                  Lei nº 12.715/12 – Institui os programas PRONON e PRONAS/PCD
                </S.SectionIntergrityProgramText>
              </li>
              <li>
                <S.SectionIntergrityProgramText>
                  Lei n° 12.213/10 – Fundo do Idoso
                </S.SectionIntergrityProgramText>
              </li>
              <li>
                <S.SectionIntergrityProgramText>
                  Lei nº 11.438/06 – Lei de Incentivo ao Esporte
                </S.SectionIntergrityProgramText>
              </li>
              <li>
                <S.SectionIntergrityProgramText>
                  Lei nº 9.613/98 – Prevenção à Lavagem de Dinheiro
                </S.SectionIntergrityProgramText>
              </li>
              <li>
                <S.SectionIntergrityProgramText>
                  Lei nº 8.685/93 – Lei Audiovisual
                </S.SectionIntergrityProgramText>
              </li>
              <li>
                <S.SectionIntergrityProgramText>
                  Lei nº 8.313/91 – Lei Rouanet
                </S.SectionIntergrityProgramText>
              </li>
              <li>
                <S.SectionIntergrityProgramText>
                  Lei n° 8.069/90 – Fundo para a Infância e Adolescência – FIA
                </S.SectionIntergrityProgramText>
              </li>
              <li>
                <S.SectionIntergrityProgramText>
                  Lei n° 5.768/71 – Distribuição Gratuita de Prêmios
                </S.SectionIntergrityProgramText>
              </li>
              <li>
                <S.SectionIntergrityProgramText>
                  SAPIN II - Lei Francesa Anticorrupção (2016)
                </S.SectionIntergrityProgramText>
              </li>
              <li>
                <S.SectionIntergrityProgramText>
                  Guidance AFA - Diretrizes da Agência Anticorrupção Francesa
                  (2021)
                </S.SectionIntergrityProgramText>
              </li>
            </S.SectionSponsorshipPolicyList>
          </>
        }
      />
    </S.SectionSponsorshipPolicyContainer>
  );
};

export default SectionSponsorshipPolicy;
